<h2 mat-dialog-title>Upload PDF User Guide</h2>
<mat-dialog-content class="mat-typography">
  <div class="container">
    <p class="text-muted mb-3">
      Select a PDF file to upload. If a file with the same name already exists, it will be replaced.
    </p>
    <app-file-upload [(uploadSummary)]="uploadSummary"></app-file-upload>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="submitting">
    {{ submitting ? 'Uploading...' : 'Upload' }}
  </button>
</mat-dialog-actions>
